<template>
  <main>
    <ul v-for="category of categories">
      <div v-if="category.title">
        <AppSubTitle v-text="category.title"/>
      </div>

      <li 
        v-for="user of category.users || []"
        :class="{ 
          my: user._id == currentUserId,
          top: [1, 2, 3].includes(user.place),
        }"
      >
        <span v-text="user.place || '#'"/>
        <span v-text="user.login || user.phone || 'Неизвестно'"/>
        <span v-text="user.score"/>
      </li>
    </ul>
  </main>
</template>


<script>
import AppSubTitle from '../ui/AppSubTitle';

export default {
  name: 'AppRating_Table',

  components: {
    AppSubTitle,
  },

  props: {
    data: Array,
    currentUserId: String,
  },

  computed: {
    categories() {
      if (!this.data) return [{ title: 'Ошибка' }];
      if (!this.data.length) return [{ title: 'Данные отсутствуют' }];
      return this.data;
    },
  },
};
</script>


<style lang="scss" scoped>
main {
  display: flex;
  flex-direction: column;
  background: linear-gradient(320deg, #c7b2f780, #d9f85580 50%, #f0724a80 90%);
  border-radius: 0 0 10px 10px;
  backdrop-filter: blur(40px);
  position: relative;
  padding: 12px 8px;
  margin-top: -3px;
  gap: 8px;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    padding: 2px;
    pointer-events: none;
    border-radius: inherit;
    background: linear-gradient(140deg, #fff, #fff0);
    -webkit-mask: 
      linear-gradient(#fff 0 0) content-box, 
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
            mask-composite: exclude;
  }

  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;

    & > div {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      text-align: center;
      padding: 8px;

      &::before {
        content: "";
        position: absolute;
        inset: 0;
        backdrop-filter: brightness(2);
        border-radius: 8px;
      }

      & > h2 {
        z-index: 1;
      }
    }

    li {
      margin: 0;
      padding: 0;
      display: flex;
      font-size: 16px;
      font-weight: bold;
      font-family: Arial, Helvetica, sans-serif;
      align-items: center;
      gap: 6px;

      &.top, &.my {
        span:nth-of-type(1) {
          background-color: var(--color-secondary);
          color: var(--color-white);
        }
      }

      span:nth-of-type(1) {
        background-color: var(--color-white);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--color-primary);
        height: 38px;
        width: 38px;
      }

      span:nth-of-type(2) {
        text-align: left;
      }

      span:nth-of-type(3) {
        margin-left: auto;
        margin-right: .2em;
      }
    }
  }

  @media screen and (min-width: 800px) and (orientation: landscape) {
    padding: 14px 16px 16px;
    margin-top: -5px;
    gap: 12px;

    &::before {
      padding: 4px;
    }

    ul {
      gap: 12px;

      li {
        font-size: 20px;
        gap: 12px;

        span:nth-of-type(1) {
          width: 48px;
          height: 48px;
        }
      }
    }
  }
}
</style>